"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetHandle = void 0;
const sharedUtils_1 = require("src/utils/sharedUtils");
const LocalStorageController_1 = require("src/classes/LocalStorageController");
const AdoptyLink_1 = require("src/projects/Widget/shadowDOM/hotspots/AdoptyLink");
const AdoptyTooltip_1 = require("src/projects/Widget/shadowDOM/hotspots/AdoptyTooltip");
const AdoptyModal_1 = require("src/projects/Widget/shadowDOM/tours/AdoptyModal");
const AdoptyPopover_1 = require("src/projects/Widget/shadowDOM/tours/AdoptyPopover");
const mutationObserver_1 = require("src/projects/Widget/utils/mutationObserver");
const DOMSelectorCleaner_1 = require("src/projects/Widget/utils/DOMSelectorCleaner");
const EventHandler_1 = __importDefault(require("src/projects/Widget/main/EventHandler"));
const TourController_1 = __importDefault(require("src/projects/Widget/main/TourController"));
const Constructor_1 = __importDefault(require("src/projects/Widget/gateway/Constructor"));
const Widget_1 = __importDefault(require("src/projects/Widget/gateway/Widget"));
class WidgetHandle extends DOMSelectorCleaner_1.DOMSelectorCleaner {
    get user() {
        return this._user;
    }
    set user(data) {
        this._user = data;
    }
    get user_token() {
        return this._user_token;
    }
    set user_token(data) {
        this._user_token = data;
    }
    get hotspots() {
        return this._hotspots;
    }
    set hotspots(data) {
        this._hotspots = data;
    }
    get tours() {
        return this._tours;
    }
    set tours(data) {
        this._tours = data;
    }
    get widget() {
        return this._widget;
    }
    get widget_key() {
        return this._widget_key;
    }
    get TourController() {
        return this.tourController;
    }
    constructor() {
        console.log("[WidgetHandle.constructor]");
        super();
        this.GatewayConstructor = () => {
            return this._constructor;
        };
        this.observe = () => {
            console.log("[WidgetHandle.observe]");
            this._mutationObserverInstance = new mutationObserver_1.MutationObserverWrapper(this, { setLocation: this.set_current_page });
            return this._mutationObserverInstance.startObserving();
        };
        this.send_user_to_handle = (data) => {
            console.log("[WidgetHandle.send_user_to_handle]");
            this.user = data.user;
            this.user_token = this.user.token;
            this.localStorageController.set("visitor_token", this.user.token);
            this.checkTourStart();
        };
        this.send_data_to_handle = (data) => {
            var _a;
            console.log("[WidgetHandle.send_data_to_handle]");
            this.isAdmin = data.isAdmin;
            if (data.hotspots) {
                this.hotspots = data.hotspots || [];
                (_a = this._mutationObserverInstance) === null || _a === void 0 ? void 0 : _a.checkElements();
            }
            if (data.tours) {
                this.tours = data.tours;
            }
            this.check_constructor_access();
            this.checkTourStart();
        };
        this.destroy_modal = () => {
            console.log("[WidgetHandle.destroy_modal]");
            this.$("adopty-modal").remove();
        };
        // Не понял зачем
        this.set_current_page = () => {
            console.log("[WidgetHandle.setCurrentPage]");
            // if (this._current_page !== window.location.pathname) {
            // 	this._current_page = getCurrentPage();
            // 	if (this.isAdmin) {
            // 		this._constructor.setPage(this._current_page);
            // 	}
            // 	// Возможно это не здесь надо делать
            // 	// if (!this.localStorageController.get("tour")?.value) {
            // 	// 	this.tourController.autostartTour();
            // 	// }
            // }
        };
        this.init = (widget_key) => {
            var _a;
            if (this._widget_key)
                return;
            console.log("[WidgetHandle.init]", widget_key);
            const ctx = this;
            ctx._widget_key = widget_key;
            ctx.user_token = (_a = ctx.localStorageController.get("visitor_token")) === null || _a === void 0 ? void 0 : _a.value;
            ctx.defineCustomElements();
            ctx.applyStyles();
            ctx.tourController = new TourController_1.default(this);
            ctx._widget = new Widget_1.default(this);
            document.addEventListener("click", function (e) {
                const target = e.target;
                if (target.hasAttribute("data-adopty_tour_id") && target.tagName !== "ADOPTY-MODAL") {
                    e.stopPropagation();
                    e.preventDefault();
                    ctx.tourController.startTour({ id: target.getAttribute("data-adopty_tour_id"), step: 0 });
                }
                if (target.hasAttribute("href") &&
                    /adopty-tour-id=/.test(target.getAttribute("href")) &&
                    target.tagName !== "ADOPTY-MODAL") {
                    if (target.getAttribute("href").split("#adopty-tour-id=")[1]) {
                        e.stopPropagation();
                        e.preventDefault();
                        window.location.hash = "";
                        ctx.tourController.startTour({ id: target.getAttribute("href").split("#adopty-tour-id=")[1], step: 0 });
                    }
                }
            });
        };
        this.hotspots = [];
        this.tours = [];
        this.user = null;
        this._mutationObserverInstance = null;
        this._postMessageHandlerMap = {
            observe: this.observe,
            destroy_modal: this.destroy_modal,
            send_data_to_handle: this.send_data_to_handle,
            send_user_to_handle: this.send_user_to_handle,
            constructorLoaded: () => this._constructor.onConstructorLoaded(),
            stop_selecting: (hide_selection) => this._constructor.onStopSelecting(hide_selection),
            show_selection: (data) => this._constructor.onShowSelection(data),
            select_element_mode: (data) => this._constructor.onSelectElementMode(data),
            change_side: (side) => this._constructor.onChangeSide(side),
            constructorFullScreen: (mode) => this._constructor.onConstructorFullScreen(mode),
            close_constructor: () => this._constructor.onClose(),
            runTourDemoMode: (data) => this._constructor.onTourDemoMode(data),
            add_hotspot: (data) => this._constructor.onAddHotspot(data),
            update_hotspot: (data) => this._constructor.onUpdateHotspot(data),
            update_hotspots: (data) => this._constructor.onUpdateHotspots(data),
            remove_hotspot: (data) => this._constructor.onRemoveHotspot(data),
            update_tour: (data) => this._constructor.onUpdateTour(data),
            show_tour_step: (data) => this._constructor.onShowTourStep(data),
            hide_tour_step: () => this._constructor.onHideTourStep(),
            widgetLoaded: () => this.widget.onWidgetLoaded(),
        };
        new EventHandler_1.default(this._postMessageHandlerMap).register();
        this.localStorageController = new LocalStorageController_1.LocalStorageController({ periodInMs: 60000, autoremove: true });
        this.asyncApply();
    }
    asyncApply() {
        console.log("[WidgetHandle.asyncApply]");
        const list = window["adoptyasync"] || [];
        if (list.length > 0 && list[0] == "init") {
            const arg = list[1];
            window["adopty"]["init"] = this.init;
            window["adoptyasync"].splice(0, 2);
            this.init.apply(null, arg);
            return;
        }
        window["adopty"]["identify"] = this.widget.identify;
        window["adopty"]["constructor"] = this.GatewayConstructor;
        window["adopty"]["onReady"] = (callback) => {
            callback();
        };
        for (let i = 0; i < list.length; i += 2) {
            if (typeof window["adopty"][list[i]] == "function") {
                window["adopty"][list[i]].apply(null, list[i + 1]);
            }
            else {
                console.error(`[WidgetHandle.constructor]: unknown method '${list[i]}`);
            }
        }
        delete window["adoptyasync"];
    }
    defineCustomElements() {
        console.log("[WidgetHandle.defineCustomElements]");
        customElements.define("adopty-tooltip", AdoptyTooltip_1.AdoptyTooltip);
        customElements.define("adopty-link", AdoptyLink_1.AdoptyLink);
        customElements.define("adopty-modal", AdoptyModal_1.AdoptyModal);
        customElements.define("adopty-popover", AdoptyPopover_1.AdoptyPopover);
    }
    applyStyles() {
        console.log("[WidgetHandle.applyStyles]");
        const link = document.createElement("link");
        link.setAttribute("href", `${sharedUtils_1.dev_env_object.STATIC_BASE_URL}/assets/css/widget.css`);
        link.setAttribute("type", "text/css");
        link.setAttribute("rel", "stylesheet");
        this.$("body").appendChild(link);
    }
    check_constructor_access() {
        console.log("[WidgetHandle.check_constructor_access]");
        if (this.isAdmin) {
            this._constructor = new Constructor_1.default(this);
        }
    }
    checkTourStart() {
        var _a;
        if ((!this.TourController.isDemoMode && !this.user) || this.tours.length == 0)
            return;
        if ((_a = this.localStorageController.get("tour")) === null || _a === void 0 ? void 0 : _a.value) {
            this.tourController.startTour({});
        }
        else if (!this.autostartChecked) {
            this.autostartChecked = true;
            this.tourController.autostartTour();
        }
    }
}
exports.WidgetHandle = WidgetHandle;
const widgetHandle = new WidgetHandle();
